import { ReportingPage } from '@/pages/crm/reporting/ReportingPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// Range + pipeline held in URL state so a report is shareable by link (AC11).
// `from`/`to` are ISO dates; absent means the server's last-90-days default.
// `pipeline` is a pipeline id or the sentinel 'all'; absent means the default pipeline.
const reportingSearchSchema = z.object({
	from: z.string().optional(),
	to: z.string().optional(),
	pipeline: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/reporting/')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['crmReporting.read'], redirectTo: '/dashboard' }),
	component: ReportingPage,
	validateSearch: reportingSearchSchema,
});
